import { Modal } from "antd";

import Resources from "scripts/resources";

import LoadingImg from "images/loading.png";

const Component = () => (
	<Modal
		className="sp-loading"
		closable={false}
		closeIcon={false}
		footer={false}
		maskClosable={false}
		maskTransitionName={false}
		transitionName={false}
		open
	>
		<img
			src={LoadingImg}
			alt=""
			className="logo"
		/>
		<span className="text">{Resources.loadingText}</span>
		<span className="loader" />
	</Modal>
);

export default Component;
